import styled from 'styled-components';

const Wrapper = styled.header`
  margin: 0 auto;
  max-width: 650px;
  padding: 0 50px 50px;
  text-align: center;
`;

export default Wrapper;